import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';
import Skeleton from 'react-loading-skeleton';
import { AuthenticatedRoute } from './AuthenticatedRoute';
import { isWebView } from '../Utilities';
import Dashboard from '../Components/Dashboard/Dashboard';
import { AuthenticatedRouteWithoutSidebar } from './AuthenticatedRouteWithoutSidebar';

const Admissions = Loadable({
  loader: () => import(/* webpackChunkName: 'Admissions' */ '../Components/Admissions/Admissions'),
  loading: Loading,
});

const ServiceUnavailable = Loadable({
  loader: () => import('../Components/Common/ServiceUnavailable/ServiceUnavailable'),
  loading: Loading,
});

const AppSettings = Loadable({
  loader: () => import('../Components/Common/PageHeader/AppSettings'),
  loading: Loading,
});

const MyCreditProfile = Loadable({
  loader: () => import('../Components/MyCreditProfile/MyCreditProfile'),
  loading: Loading,
});

const CreditsAnalytics = Loadable({
  loader: () => import('../Components/Credits/CreditsAnalytics'),
  loading: Loading,
});

const PaymentSettings = Loadable({
  loader: () => import('../Components/Common/PageHeader/PaymentSettings'),
  loading: Loading,
});

const LoginSettings = Loadable({
  loader: () => import('../Components/Common/PageHeader/LoginSettings'),
  loading: Loading,
});

const SettlementsPage = Loadable({
  loader: () => import('../Components/Common/Settlements/Settlements'),
  loading: Loading,
});

const SettlementsBreakdown = Loadable({
  loader: () => import('../Components/Common/Settlements/SettlementsBreakdown'),
  loading: Loading,
});

const StudentServiceUnavailable = Loadable({
  loader: () => import('../Components/Common/ServiceUnavailable/StudentServiceUnavailable'),
  loading: Loading,
});

const BrowserRestricted = Loadable({
  loader: () => import('../Components/Login/BrowserRestricted/BrowserRestricted'),
  loading: Loading,
});

const VideoShow = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'Admissions' */ '../Components/Common/VideoPlayer/DrmVideoplayer/VideoShow'
    ),
  loading: Loading,
});

// import Admissions from '../Components/Admissions/Admissions';

const ForgotPassword = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'ForgotPassword' */ '../Components/Login/SignIn/ForgotPassword/ForgotPassword'
    ),
  loading: Loading,
});
// import ForgotPassword from '../Components/Login/SignIn/ForgotPassword/ForgotPassword';

const OldFileView = Loadable({
  loader: () =>
    // import(
    //   /* webpackChunkName: 'PDFFileViewer' */ '../Components/Common/FileViewer/PDFFinalViewer'
    // ),
    import(/* webpackChunkName: 'PDFFileViewer' */ '../Components/Common/FileViewer/PDFFileViewer'),
  loading: Loading,
});
const FileView = Loadable({
  loader: () =>
    // import(
    //   /* webpackChunkName: 'PDFFileViewer' */ '../Components/Common/FileViewer/PDFFinalViewer'
    // ),
    import(
      /* webpackChunkName: 'PDFFileViewer' */ '../Components/Common/FileViewer/PDFFileViewerOld'
    ),
  loading: Loading,
});
const TempViewFile = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'OtherFileView' */ '../Components/Common/FileViewer/FileViewer'),
  loading: Loading,
});

const PaymentPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'OtherFileView' */ '../Components/Common/PaymentPage/PaymentPage'),
  loading: Loading,
});

import Login from '../Components/Login/Login';

const Preloader = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Preloader' */ '../Components/Login/Preloader/Preloader'),
  loading: Loading,
});

const AuthenticateUser = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Preloader' */ '../Components/Login/Preloader/AuthenticateUser'),
  loading: Loading,
});

const SignupForm = Loadable({
  loader: () => import(/* webpackChunkName: 'SignUpForm' */ '../Components/Login/SignupForm'),
  loading: Loading,
});

const FinishSetup = Loadable({
  loader: () => import(/* webpackChunkName: 'SignUpForm' */ '../Components/Login/FinishSetup'),
  loading: Loading,
});

const SignIn = Loadable({
  loader: () => import(/* webpackChunkName: 'SignIn' */ '../Components/Login/SignIn/SignIn'),
  loading: Loading,
});
// import SignIn from '../Components/Login/SignIn/SignIn';

const SignUp = Loadable({
  loader: () => import(/* webpackChunkName: 'SignUp' */ '../Components/Login/SignUp/SignUp'),
  loading: Loading,
});
// import SignUp from '../Components/Login/SignUp/SignUp';

const AdmissionChat = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'AdmissionChat' */ '../Components/Login/AdmissionChat/AdmissionChat'
    ),
  loading: Loading,
});
// import AdmissionChat from '../Components/Login/AdmissionChat/AdmissionChat';

const AdmissionForm = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'AdmissionForm' */ '../Components/Login/AdmissionChat/AdmissionForm/AdmissionForm'
    ),
  loading: Loading,
});
// import AdmissionForm from '../Components/Login/AdmissionChat/AdmissionForm/AdmissionForm';

const StudyBin = Loadable({
  loader: () => import(/* webpackChunkName: 'StudyBin' */ '../Components/Study Bin/StudyBin'),
  loading: Loading,
});
// import StudyBin from '../Components/Study Bin/StudyBin';

const Videos = Loadable({
  loader: () => import(/* webpackChunkName: 'StudyBin' */ '../Components/Videos/Videos'),
  loading: Loading,
});
// import StudyBin from '../Components/Videos/Videos';

const Categories = Loadable({
  loader: () => import(/* webpackChunkName: 'Categories' */ '../Components/Study Bin/Categories'),
  loading: Loading,
});
// import Categories from '../Components/Study Bin/Categories';

const AddYoutube = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'AddYoutube' */ '../Components/Common/AddYoutube/AddYoutube'),
  loading: Loading,
});

const QuestionTakerNew = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuestionTaker' */ '../Components/Common/QuestionTaker/QuestionTakerNew'
    ),
  loading: Loading,
});


const QuestionTaker = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuestionTaker' */ '../Components/Common/QuestionTaker/QuestionTaker'
    ),
  loading: Loading,
});


const NoticeBoard = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'NoticeBoard' */ '../Components/NoticeBoard/NoticeBoard'),
  loading: Loading,
});
// import NoticeBoard from '../Components/NoticeBoard/NoticeBoard';

const Profile = Loadable({
  loader: () => import(/* webpackChunkName: 'Profile' */ '../Components/Profile/Profile'),
  loading: Loading,
});

const MulyankanProfile = Loadable({
  loader: () => import(/* webpackChunkName: 'Profile' */ '../Components/Profile/MulyankanProfile'),
  loading: Loading,
});
// import Profile from '../Components/Profile/Profile';

const EditProfile = Loadable({
  loader: () => import(/* webpackChunkName: 'EditProfile' */ '../Components/Profile/EditProfile'),
  loading: Loading,
});
// import EditProfile from '../Components/Profile/EditProfile';

const FeesOrder = Loadable({
  loader: () => import(/* webpackChunkName: 'FeesOrder' */ '../Components/Fees/Fees.order'),
  loading: Loading,
});
// import FeesOrder from '../Components/Fees/Fees.order';

const FeeOrderSummary = Loadable({
  loader: () => import(/* webpackChunkName: 'FeesOrder' */ '../Components/Fees/CFOrderSummary'),
  loading: Loading,
});

const AppointmentOrderSummary = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'FeesOrder' */ '../Components/Appointments/AppointmentOrderSummary'
    ),
  loading: Loading,
});

const AppointmentInvoices = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'FeesOrder' */ '../Components/Appointments/AppointmentInvoices'),
  loading: Loading,
});

const HomeWorkCreator = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'HomeWorkCreator' */ '../Components/HomeWorkCreator/HomeWorkCreator'
    ),
  loading: Loading,
});

const QuickTest = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuickTest' */ '../Components/HomeworkCreatorNew/CreateTest/QuickTest'
    ),
  loading: Loading,
});

const AnalysisNew = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'AnalysisNew' */ '../Components/HomeworkCreatorNew/AnalysisNew/AnalysisNew'
    ),
  loading: Loading,
});

const HomeWorkCreatorNew = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'HomeworkCreatorNew' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/HomeworkCreatorNew'
    ),
  loading: Loading,
});

const NotAvailable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'HomeworkCreatorNew' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/NotAvailable'
    ),
  loading: Loading,
});

const ConfigurePaper = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'ConfigurePaper' */ '../Components/HomeworkCreatorNew/CreateTest/ConfigurePaper'
    ),
  loading: Loading,
});

const RecentUploads = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuestionEditorNew' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/RecentPdfs'
    ),
  loading: Loading,
});

const QuestionEditorNew = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuestionEditorNew' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/QuestionEditorNew'
    ),
  loading: Loading,
});

const QuestionBank = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuestionBank' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/QuestionBank'
    ),
  loading: Loading,
});

const PractiseModule = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'PractiseSection' */ '../Components/HomeworkCreatorNew/PractiseSection/PractiseModule'
    ),
  loading: Loading,
});

const PractisePage = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'PractiseSection' */ '../Components/HomeworkCreatorNew/PractiseSection/PractisePage'
    ),
  loading: Loading,
});

const SubjectFilter = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'PractiseSection' */ '../Components/HomeworkCreatorNew/PractiseSection/SubjectFilter'
    ),
  loading: Loading,
});

const CreateTest = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'CreateTest' */ '../Components/HomeworkCreatorNew/CreateTest/CreateTest'
    ),
  loading: Loading,
});

const CreateTestNew = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'CreateTest' */ '../Components/HomeworkCreatorNew/CreateTestNew/CreateTestNew'
    ),
  loading: Loading,
});

const ReviewTest = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'CreateTest' */ '../Components/HomeworkCreatorNew/CreateTest/ReviewTest'
    ),
  loading: Loading,
});

const GoPro = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'GoPro' */ '../Components/HomeworkCreatorNew/GoPro/GoPro'),
  loading: Loading,
});

const FinalQuestionsDownload = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuestionEditorNew' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/FinalQuestionsDownload'
    ),
  loading: Loading,
});

const FinalQuestionsDownloadNew = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuestionEditorNew' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/FinalQuestionsDownloadNew'
    ),
  loading: Loading,
});

const BulkUpload = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuestionEditorNew' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/BulkUpload'
    ),
  loading: Loading,
});



const PdfQuestionExtractor = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'PdfQuestionExtractor' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/PdfQuestionExtractor'
    ),
  loading: Loading,
});

// const BulkUpload = Loadable({
//   loader: () =>
//     import(/* webpackChunkName: 'HomeWorkCreator' */ '../Components/HomeWorkCreator/BulkUpload'),
//   loading: Loading,
// });
// import HomeWorkCreator from '../Components/HomeWorkCreator/HomeWorkCreator';

const SavedSentTests = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'SavedSentTests' */ '../Components/HomeWorkCreator/SavedSentTests'),
  loading: Loading,
});
// import SavedSentTests from '../Components/HomeWorkCreator/SavedSentTests';

const SavedSentTestsUsingFilters = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'SavedSentTestsUsingFilters' */ '../Components/HomeWorkCreator/SavedSentTestsUsingFilters'
    ),
  loading: Loading,
});

const FinalQuestions = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'FinalQuestions' */ '../Components/HomeWorkCreator/FinalQuestions'),
  loading: Loading,
});

const FinalQuestionsNew = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'FinalQuestions' */ '../Components/HomeworkCreatorNew/CreateTest/FinalQuestionsNew'
    ),
  loading: Loading,
});

const CreatedTest = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'FinalQuestions' */ '../Components/HomeworkCreatorNew/CreateTest/CreatedTest'
    ),
  loading: Loading,
});

const AllCreatedTestsMulyankan = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'FinalQuestions' */ '../Components/HomeworkCreatorNew/CreateTest/AllCreatedTestsMulyankan'
    ),
  loading: Loading,
});

const AllCreatedTests = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'FinalQuestions' */ '../Components/HomeworkCreatorNew/CreateTest/AllCreatedTests'
    ),
  loading: Loading,
});
// import FinalQuestions from '../Components/HomeWorkCreator/FinalQuestions';

const CreateQuestion = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'CreateQuestion' */ '../Components/HomeWorkCreator/CreateQuestion'),
  loading: Loading,
});

const TestsMain = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'CreateQuestion' */ '../Components/HomeworkCreatorNew/CreateTest/TestsMain'
    ),
  loading: Loading,
});

const ManageFilters = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'QuestionEditorNew' */ '../Components/HomeworkCreatorNew/QuestionEditorNew/ManageFilters'
    ),
  loading: Loading,
});
// import CreateQuestion from '../Components/HomeWorkCreator/CreateQuestion';

const HomeWorkAssigner = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'HomeWorkAssigner' */ '../Components/HomeWorkCreator/HomeWorkAssigner'
    ),
  loading: Loading,
});
// import HomeWorkAssigner from '../Components/HomeWorkCreator/HomeWorkAssigner';

const HomeWorkViewOnly = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'HomeWorkViewOnly' */ '../Components/HomeWorkCreator/HomeWorkViewOnly'
    ),
  loading: Loading,
});

const Campaign = Loadable({
  loader: () => import(/* webpackChunkName: 'Campaign' */ '../Components/Campaign/Campaign'),
  loading: Loading,
});

const CampaignDashboard = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Campaign' */ '../Components/Campaign/CampaignDashboard'),
  loading: Loading,
});

const CampaignDetails = Loadable({
  loader: () => import(/* webpackChunkName: 'Campaign' */ '../Components/Campaign/CampaignDetails'),
  loading: Loading,
});

const ViewCourses = Loadable({
  loader: () => import(/* webpackChunkName: 'ViewCourses' */ '../Components/Courses/ViewCourses'),
  loading: Loading,
});
// import ViewCourses from '../Components/Courses/ViewCourses';

const TeacherCourses = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'TeacherCourses' */ '../Components/Courses/TeacherCourses'),
  loading: Loading,
});

const CourseInvoice = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'TeacherCourses' */ '../Components/Courses/CourseInvoice'),
  loading: Loading,
});

const CourseInvoiceSeparate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'TeacherCourses' */ '../Components/Courses/CourseInvoiceSeparate'
    ),
  loading: Loading,
});

const FeeInvoice = Loadable({
  loader: () => import(/* webpackChunkName: 'TeacherCourses' */ '../Components/Fees/FeeInvoice'),
  loading: Loading,
});

// import TeacherCourses from '../Components/Courses/TeacherCourses';

const BuyCourse = Loadable({
  loader: () => import(/* webpackChunkName: 'BuyCourse' */ '../Components/Courses/BuyCourse'),
  loading: Loading,
});

const CourseCheckout = Loadable({
  loader: () => import(/* webpackChunkName: 'CourseCheckout' */ '../Components/Courses/CourseCheckout'),
  loading: Loading,
});

const CourseLandingPage = Loadable({
  loader: () => import(/* webpackChunkName: 'CourseLandingPage' */ '../Components/Courses/CourseLandingPage'),
  loading: Loading,
});



const CourseLandingPage3 = Loadable({
  loader: () => import(/* webpackChunkName: 'CourseLandingPage3' */ '../Components/Courses/CourseLandingPage3'),
  loading: Loading,
});


const SubscriptionPauseLogs = Loadable({
  loader: () => import(/* webpackChunkName: 'SubscriptionPauseLogs' */ '../Components/Courses/SubscriptionPauseLogs'),
  loading: Loading,
});

const CourseAnalysis = Loadable({
  loader: () => import(/* webpackChunkName: 'BuyCourse' */ '../Components/Courses/CourseAnalysis'),
  loading: Loading,
});
// import BuyCourse from '../Components/Courses/BuyCourse';

const Mycourse = Loadable({
  loader: () => import(/* webpackChunkName: 'MyCourse' */ '../Components/Courses/MyCourse'),
  loading: Loading,
});

const MycourseWithoutPlayer = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'MyCourse' */ '../Components/Courses/MyCourseWithoutPlayer'),
  loading: Loading,
});

const AllCourses = Loadable({
  loader: () => import(/* webpackChunkName: 'MyCourse' */ '../Components/Courses/AllCourses'),
  loading: Loading,
});
const ExploreAllCourses = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'MyCourse' */ '../Components/Courses/ExploreAllCourses'),
  loading: Loading,
});
// import Mycourse from '../Components/Courses/MyCourse';

const Certificate = Loadable({
  loader: () => import(/* webpackChunkName: 'MyCourse' */ '../Components/Courses/Certificate'),
  loading: Loading,
});
// import Certificate from '../Components/Courses/Certificate';

// const Dashboard = Loadable({
//   loader: () => import(/* webpackChunkName: 'Dashboard' */ '../Components/Dashboard/Dashboard'),
//   loading: Loading,
// });
// import Dashboard from '../Components/Dashboard/Dashboard';

const LiveClasses = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveClasses' */ '../Components/Live Classes/LiveClasses'),
  loading: Loading,
});

const CreateAppointment = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveClasses' */ '../Components/Appointments/CreateAppointment'),
  loading: Loading,
});

const CreateAvailability = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveClasses' */ '../Components/Appointments/CreateAvailability'),
  loading: Loading,
});

const AllAppointments = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveClasses' */ '../Components/Appointments/AllAppointments'),
  loading: Loading,
});

const BookAppointment = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveClasses' */ '../Components/Appointments/BookAppointment'),
  loading: Loading,
});

const BookingCheckout = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveClasses' */ '../Components/Appointments/BookingCheckout'),
  loading: Loading,
});

const PlyrVideoPlayer = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'VideoPlayer' */ '../Components/Common/VideoPlayer/PlyrVideoPlayer'
    ),
  loading: Loading,
});

const YoutubePlayer = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'VideoPlayer' */ '../Components/Common/VideoPlayer/YoutubePlayer'),
  loading: Loading,
});

const PlyrHlsVideoPlayer = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'VideoPlayer' */ '../Components/Common/VideoPlayer/PlyrHlsVideoPlayer'
    ),
  loading: Loading,
});

const CourseStatistics = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'CourseStats' */ '../Components/Courses/CourseStatistics'),
  loading: Loading,
});
// import CourseStatistics from '../Components/Courses/CourseStatistics';

const CreateCourse = Loadable({
  loader: () => import(/* webpackChunkName: 'CreateCourse' */ '../Components/Courses/CreateCourse'),
  loading: Loading,
});

const ManageCategories = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'CreateCourse' */ '../Components/Courses/ManageCategories'),
  loading: Loading,
});

const ManageValidity = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'CreateCourse' */ '../Components/Courses/ManageValidity'),
  loading: Loading,
});

const UpdatedValidityList = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'CreateCourse' */ '../Components/Courses/UpdatedValidityList'),
  loading: Loading,
});
// import CreateCourse from '../Components/Courses/CreateCourse';

const AddContent = Loadable({
  loader: () => import(/* webpackChunkName: 'AddContent' */ '../Components/Courses/AddContent'),
  loading: Loading,
});
// import AddContent from '../Components/Courses/AddContent';

const UserDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'UserDetails' */ '../Components/Admissions/UsersDetails'),
  loading: Loading,
});
// import UserDetails from '../Components/Admissions/UsersDetails';

const BatchDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'BatchDetails' */ '../Components/Admissions/BatchesDetails'),
  loading: Loading,
});
// import BatchDetails from '../Components/Admissions/BatchesDetails';

const AddUsersToBatch = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'BatchDetails' */ '../Components/Admissions/AddUserToBatch'),
  loading: Loading,
});
// import BatchDetails from '../Components/Admissions/BatchesDetails';

const AddDetails = Loadable({
  loader: () => import(/* webpackChunkName: 'AddDetails' */ '../Components/Admissions/AddDetails'),
  loading: Loading,
});
// import AddDetails from '../Components/Admissions/AddDetails';

const AddFees = Loadable({
  loader: () => import(/* webpackChunkName: 'AddFees' */ '../Components/Admissions/AddFees'),
  loading: Loading,
});

const Notifications = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'BatchDetails' */ '../Components/Notifications/Notifications'),
  loading: Loading,
});
// import AddFees from '../Components/Admissions/AddFees';

const SelectClass = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'SelectClass' */ '../Components/Admissions/SelectClass'),
  loading: Loading,
});
// import SelectClass from '../Components/Admissions/SelectClass';

const AddBatch = Loadable({
  loader: () => import(/* webpackChunkName: 'AddBatch' */ '../Components/Admissions/AddBatch'),
  loading: Loading,
});
// import AddBatch from '../Components/Admissions/AddBatch';

const EditProfileHOC = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'EditProfileHoc' */ '../Components/Admissions/EditProfileHoC'),
  loading: Loading,
});

const Fees = Loadable({
  loader: () => import(/* webpackChunkName: 'Fees' */ '../Components/Fees/Fees'),
  loading: Loading,
});

const TeacherFees = Loadable({
  loader: () => import(/* webpackChunkName: 'TeacherFees' */ '../Components/Fees/TeacherFees'),
  loading: Loading,
});

const FeeUserDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'FeeUserDetails' */ '../Components/Fees/FeeUserDetails'),
  loading: Loading,
});

const StudentFee = Loadable({
  loader: () => import(/* webpackChunkName: 'StudentFee' */ '../Components/Fees/StudentFee'),
  loading: Loading,
});

const FeePlans = Loadable({
  loader: () => import(/* webpackChunkName: 'FeePlans' */ '../Components/Fees/FeePlans'),
  loading: Loading,
});

// import StudentFee from '../Components/Fees/StudentFee';

const EditFeePlan = Loadable({
  loader: () => import(/* webpackChunkName: 'EditFeePlan' */ '../Components/Fees/EditFeePlan'),
  loading: Loading,
});

const TeacherAnalysis = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'TeacherAnalysis' */ '../Components/Analysis/TeacherAnalysis'),
  loading: Loading,
});

const AssignmentList = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'AssignmentList' */ '../Components/Analysis/AssignmentList'),
  loading: Loading,
});

const SubjectiveAnalysis = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'AssignmentList' */ '../Components/Analysis/SubjectiveAnalysis'),
  loading: Loading,
});

const StudentAnalysis = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'StudentAnalysis' */ '../Components/Analysis/StudentAnalysis'),
  loading: Loading,
});

const StudentSubjectiveAnalysis = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'StudentAnalysis' */ '../Components/Analysis/StudentSubjectiveAnalysis'
    ),
  loading: Loading,
});

const StudentList = Loadable({
  loader: () => import(/* webpackChunkName: 'StudentList' */ '../Components/Analysis/StudentList'),
  loading: Loading,
});
const StudentInvoices = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveClasses' */ '../Components/ClientInvoices/StudentInvoices'),
  loading: Loading,
});
const ClientInvoices = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveClasses' */ '../Components/ClientInvoices/ClientInvoices'),
  loading: Loading,
});
const ClientInvoice = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'LiveClasses' */ '../Components/ClientInvoices/ClientInvoice'),
  loading: Loading,
});

const FourZeroFour = Loadable({
  loader: () => import(/* webpackChunkName: 'FourZeroFour' */ '../Components/ErrorPages/404'),
  loading: Loading,
});

const InvalidURL = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'FourZeroFour' */ '../Components/ErrorPages/InvalidURL'),
  loading: Loading,
});

const ErrorCode = Loadable({
  loader: () => import(/* webpackChunkName: 'ErrorCode' */ '../Components/ErrorPages/ErrorCode'),
  loading: Loading,
});

const InvalidCourse = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'InvalidCourse' */ '../Components/ErrorPages/InvalidCourse'),
  loading: Loading,
});

const Attendance = Loadable({
  loader: () => import(/* webpackChunkName: 'Attendance' */ '../Components/Attendance/Attendance'),
  loading: Loading,
});

const AttendanceBatch = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Attendancebatch' */ '../Components/Attendance/AttendanceBatch'),
  loading: Loading,
});

const Analysis = Loadable({
  loader: () => import(/* webpackChunkName: 'Attendance' */ '../Components/Attendance/Analysis'),
  loading: Loading,
});

const SelectedDateAttendance = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'SelectedDate' */ '../Components/Attendance/SelectedDateAttendance'
    ),
  loading: Loading,
});

const DisplayPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'DisplayPage' */ '../Components/DisplayPage/DisplayPage'),
  loading: Loading,
});

const DisplayPageEdit = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'DisplayPageEdit' */ '../Components/DisplayPage/DisplayPageEdit'),
  loading: Loading,
});

const DummyDashboard = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'DummyDashPage' */ '../Components/Login/DummyDashboard'),
  loading: Loading,
});

const DummyDashboard2 = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'DummyDashPage' */ '../Components/Login/DummyDashboard2'),
  loading: Loading,
});

const OfflineAssignments = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'OfflineAssignments' */ '../Components/OfflineAssignments/OfflineAssignments'
    ),
  loading: Loading,
});

const AssignmentForm = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'AssignmentForm' */ '../Components/OfflineAssignments/AssignmentForm'
    ),
  loading: Loading,
});

const EditAssignment = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'AssignmentForm' */ '../Components/OfflineAssignments/EditAssignment'
    ),
  loading: Loading,
});

const StudEdit = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'StudEdit' */ '../Components/OfflineAssignments/StudEdit'),
  loading: Loading,
});

const StudOfflineMarks = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'StudOfflineMarks' */ '../Components/OfflineAssignments/StudOfflineMarks'
    ),
  loading: Loading,
});

const CRM = Loadable({
  loader: () => import(/* webpackChunkName: 'CRMPage' */ '../Components/CRM/Crm'),
  loading: Loading,
});

const 
AILeads = Loadable({
  loader: () => import(/* webpackChunkName: 'CRMPage' */ '../Components/CRM/AILeads'),
  loading: Loading,
});

const Conversations = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Conversations' */ '../Components/Conversations/Conversations'),
  loading: Loading,
});

const Conversation = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'Conversation' */ '../Components/Conversations/Conversation'),
  loading: Loading,
});

const Chatbot = Loadable({
  loader: () => import(/* webpackChunkName: 'Chatbot' */ '../Components/Chatbot/Chatbot'),
  loading: Loading,
});

const Quiz = Loadable({
  loader: () => import(/* webpackChunkName: 'Quiz' */ '../Components/Quiz/Quiz'),
  loading: Loading,
});

const SaralLeaderboard = Loadable({
  loader: () => import(/* webpackChunkName: 'Quiz' */ '../Components/Quiz/Leaderboard'),
  loading: Loading,
});

const KaryakartaCertificate = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'karyakartaCertificate' */ '../Components/Courses/KaryakartaCertificate'
    ),
  loading: Loading,
});

const ImageEditor = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'ImageEditor' */ '../Components/Conversations/ImageEditor/ImageEditor'
    ),
  loading: Loading,
});

const ConversationDetails = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'ConversationDetails' */ '../Components/Conversations/ConversationDetails'
    ),
  loading: Loading,
});

const ConversationFiles = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'ConversationFiles' */ '../Components/Conversations/ConversationFiles/ConversationFiles'
    ),
  loading: Loading,
});

const ConversationMedia = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'ConversationMedia' */ '../Components/Conversations/ConversationMedia/ConversationMedia'
    ),
  loading: Loading,
});

const CreatePost = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'CreatePost' */ '../Components/Conversations/Posts/CreatePost'),
  loading: Loading,
});

const Post = Loadable({
  loader: () => import(/* webpackChunkName: 'Post' */ '../Components/Conversations/Posts/Post'),
  loading: Loading,
});

const ViewAllAsignments = Loadable({
  loader: () => import(/* webpackChunkName: 'Post' */ '../Components/Tests/OnlineAssignments'),
  loading: Loading,
});

// settlementPage
const SettlementPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'settlementPage' */ '../Components/Fees/SettlementPage'),
  loading: Loading,
});

const EditPayments = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'settlementPage' */ '../Components/Fees/EditSettlementPage'),
  loading: Loading,
});

const EditTaxDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'settlementPage' */ '../Components/Fees/EditTaxDetails'),
  loading: Loading,
});

const Temp = Loadable({
  loader: () => import(/* webpackChunkName: 'settlementPage' */ '../Components/Common/Temp/Temp'),
  loading: Loading,
});

const UploadPage = Loadable({
  loader: () => import(/* webpackChunkName: 'settlementPage' */ '../Components/Eomr/UploadPage'),
  loading: Loading,
});

const EomrMarking = Loadable({
  loader: () => import('../Components/Eomr/EomrMarking'),
  loading: Loading,
});

const EomrContainer = Loadable({
  loader: () => import('../Components/Eomr/createEOMR/EomrContainer'),
  loading: Loading,
});
// const TestingDash = Loadable({
//   loader: () => import('../Components/BottomNavigation/BottomNavigation'),
//   loading: Loading,
// });

const ReorderTabs = Loadable({
  loader: () => import('../Components/Common/BottomNavigation/ReOrderTabs'),
  loading: Loading,
});

const PrivacyPolicy = Loadable({
  loader: () => import('../Components/Common/PrivacyPolicy/PrivacyPolicy'),
  loading: Loading,
});

const FAQ = Loadable({
  loader: () => import('../Components/Common/PrivacyPolicy/FAQ'),
  loading: Loading,
});

const UsageUpdate = Loadable({
  loader: () => import('../Components/Usage/UsageUpdate'),
  loading: Loading,
});

const ServiceCharges = Loadable({
  loader: () => import('../Components/Usage/ServiceCharges'),
  loading: Loading,
});

const Terms = Loadable({
  loader: () => import('../Components/Common/PrivacyPolicy/Terms'),
  loading: Loading,
});
const RefundPolicy = Loadable({
  loader: () => import('../Components/Common/PrivacyPolicy/Refund'),
  loading: Loading,
});

const Usage = Loadable({
  loader: () => import(/* webpackChunkName: 'TeacherAnalysis' */ '../Components/Usage/Usage'),
  loading: Loading,
});

const Invoice = Loadable({
  loader: () => import(/* webpackChunkName: 'TeacherAnalysis' */ '../Components/Usage/Invoice'),
  loading: Loading,
});

const Transactions = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'TeacherAnalysis' */ '../Components/Usage/RecentTransactions'),
  loading: Loading,
});

const Creditpayment = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'TeacherAnalysis' */ '../Components/Usage/Creditpayment'),
  loading: Loading,
});

const RecordedStreams = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'TeacherAnalysis' */ '../Components/Study Bin/RecordedStreams'),
  loading: Loading,
});

const LiveClassRecordings = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'TeacherAnalysis' */ '../Components/Live Classes/LiveClassRecordings'
    ),
  loading: Loading,
});

const ZoomSDK = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'settlementPage' */ '../Components/Common/ZoomSDK/ZoomSDK'),
  loading: Loading,
});

const PaymentDummy = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'DummyDashPage' */ '../Components/Common/BjpComponents/PaymentSuccess'
    ),
  loading: Loading,
});

const PaymentLink = Loadable({
  loader: () => import(/* webpackChunkName: 'DummyDashPage' */ '../Components/Common/PaymentLink'),
  loading: Loading,
});

const Forms = Loadable({
  loader: () => import(/* webpackChunkName: 'DummyDashPage' */ '../Components/Forms/Forms'),
  loading: Loading,
});

const AdmissionFormResponses = Loadable({
  loader: () => import(/* webpackChunkName: 'AdmissionFormResponses' */ '../Components/Forms/AdmissionFormResponses'),
  loading: Loading,
});

const UserPermissionControl = Loadable({
  loader: () => import('../Components/Admissions/ManageUserPermission'),
  loading: Loading,
});

const UserFeatureAccess = Loadable({
  loader: () => import('../Components/Admissions/UserFeatureAccess'),
  loading: Loading,
});

const MulyankanFolders = Loadable({
  loader: () => import('../Components/Study Bin/MulyankanFolders'),
  loading: Loading,
});
// eslint-disable-next-line
function Loading({ error }) {
  if (error) {
    console.error(error);
    if (isWebView && typeof window.Android.viewOfflineData !== 'undefined') {
      window.Android.viewOfflineData(JSON.stringify({}));
    }
    return 'Unable to load the webpage. Please reload the page and try again.';
  }
  return <Skeleton count={50} />;
}

export function Routes() {
  return (
    // <div style={{ position: 'relative', width: '80vw', left: '20vw' }}>
    <>
      <Switch>
        <AuthenticatedRoute exact path='/' component={Dashboard} />
        <Route exact path='/primetest' component={Temp} />
        <Route path='/privacypolicy' component={PrivacyPolicy} />
        <Route path='/faq' component={FAQ} />
        <Route path='/termsandconditions' component={Terms} />
        <Route path='/refundpolicy' component={RefundPolicy} />
        <Route path='/signin' component={SignIn} />
        <Route path='/signup' component={SignUp} />
        <Route exact path='/login' component={Login} />
        <Route exact path='/preload' component={Preloader} />
        <Route exact path='/login/signup' component={SignupForm} />
        <Route exact path='/finish-setup' component={FinishSetup} />
        <AuthenticatedRoute path='/admission' component={AdmissionChat} />
        <AuthenticatedRouteWithoutSidebar path='/admissionform' component={AdmissionForm} />
        <Route path='/forgotpassword' component={ForgotPassword} />

        <Route path='/videoplayer/:id?' component={PlyrVideoPlayer} />
        <Route path='/youtubeplayer/:id?' component={YoutubePlayer} />
        {/* Created By Sarthak */}

        <AuthenticatedRoute path='/reorder-tabs' component={ReorderTabs} />
        <AuthenticatedRoute path='/upload-pdf' component={UploadPage} />
        <AuthenticatedRoute path='/createEomr' component={EomrContainer} />
        <AuthenticatedRoute path='/eomr/preview' component={EomrMarking} />

        {/* Ended By Sarthak */}
        <Route path='/shieldplayer/:id?' component={PlyrHlsVideoPlayer} />

        <AuthenticatedRoute exact path='/allassignments' component={ViewAllAsignments} />
        <AuthenticatedRoute exact path='/liveclasses' component={LiveClasses} />
        <AuthenticatedRoute exact path='/create-appointment' component={CreateAppointment} />
        <AuthenticatedRoute exact path='/create-availability' component={CreateAvailability} />
        <AuthenticatedRoute exact path='/all-appointments' component={AllAppointments} />
        <AuthenticatedRoute exact path='/booking-invoice' component={AppointmentInvoices} />
        <Route exact path='/book-appointment/:uuid' component={BookAppointment} />
        <Route exact path='/book-appointment-checkout' component={BookingCheckout} />
        <AuthenticatedRoute exact path='/studybin' component={StudyBin} />
        <AuthenticatedRoute exact path='/saved-yt-streams' component={RecordedStreams} />
        <AuthenticatedRoute exact path='/liveclass-recordings' component={LiveClassRecordings} />
        <AuthenticatedRouteWithoutSidebar exact path='/zoom' component={ZoomSDK} />
        <AuthenticatedRoute exact path='/studybin/categories/:id' component={Categories} />
        <AuthenticatedRoute exact path='/addyoutubevideo' component={AddYoutube} />
        <AuthenticatedRoute exact path='/noticeboard' component={NoticeBoard} />
        <AuthenticatedRoute exact path='/profile' component={Profile} />
        <AuthenticatedRoute exact path='/mulyankan-profile' component={MulyankanProfile} />
        <AuthenticatedRoute exact path='/editprofile' component={EditProfile} />
        <AuthenticatedRouteWithoutSidebar exact path='/questiontakernew' component={QuestionTakerNew} />
        <AuthenticatedRouteWithoutSidebar exact path='/questiontaker' component={QuestionTaker} />
        <AuthenticatedRoute exact path='/fees' component={Fees} />
        <AuthenticatedRoute exact path='/teacherfees' component={TeacherFees} />
        <AuthenticatedRoute exact path='/fees/users' component={FeeUserDetails} />
        <AuthenticatedRoute exact path='/fees/students' component={StudentFee} />
        <AuthenticatedRoute exact path='/fees/Feeplans' component={FeePlans} />
        <AuthenticatedRoute exact path='/fees/edit/studentfeeplan' component={EditFeePlan} />
        <AuthenticatedRoute exact path='/order' component={FeesOrder} />
        <Route exact path='/ordersummary' component={FeeOrderSummary} />
        <Route exact path='/bookingordersummary' component={AppointmentOrderSummary} />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/ordersummaryfs'
          component={FeeOrderSummary}
        />
        {/* <AuthenticatedRoute exact path='/homework' component={HomeWorkCreator} /> */}
        <AuthenticatedRoute exact path='/v2/homeworkcreator' component={HomeWorkCreatorNew} />
        <AuthenticatedRoute exact path='/v2/notavailable' component={NotAvailable} />
        <AuthenticatedRoute exact path='/configurepaper' component={ConfigurePaper} />
        <AuthenticatedRoute
          exact
          path='/v2/homeworkcreator/recentuploads'
          component={RecentUploads}
        />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/question-editor'
          component={QuestionEditorNew}
        />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/mulyankan/question-bank'
          component={QuestionBank}
        />
        <AuthenticatedRouteWithoutSidebar exact path='/question-bank' component={QuestionBank} />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/practice-question'
          component={PractiseModule}
        />
        <AuthenticatedRoute exact path='/practice/module' component={PractisePage} />
        <AuthenticatedRoute exact path='/practice' component={SubjectFilter} />
        <AuthenticatedRoute exact path='/bookmarks' component={PractisePage} />
        <AuthenticatedRoute exact path='/error-notes' component={PractisePage} />
        <AuthenticatedRouteWithoutSidebar exact path='/create-test' component={CreateTest} />
        <AuthenticatedRouteWithoutSidebar exact path='/test-creator' component={CreateTestNew} />
        <AuthenticatedRouteWithoutSidebar exact path='/review-test' component={ReviewTest} />
        <AuthenticatedRoute exact path='/go-pro' component={GoPro} />
        <AuthenticatedRoute exact path='/manage-filters' component={ManageFilters} />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/homework/bulkupload'
          component={BulkUpload}
        />
        <AuthenticatedRouteWithoutSidebar exact path='/BulkUploadDemo' component={PdfQuestionExtractor} />

        <AuthenticatedRouteWithoutSidebar
          exact
          path='/questions/download'
          component={FinalQuestionsDownload}
        />

        <AuthenticatedRouteWithoutSidebar
          exact
          path='/question-bank/download'
          component={FinalQuestionsDownloadNew}
        />

        <AuthenticatedRouteWithoutSidebar exact path='/homework/savedtests' component={SavedSentTests} />
        {/* <AuthenticatedRoute
          exact
          path='/homework/savedsent'
          component={SavedSentTestsUsingFilters}
        /> */}
        <AuthenticatedRoute exact path='/homework/preview' component={FinalQuestions} />
        <AuthenticatedRoute exact path='/homework/create' component={CreateQuestion} />
        <AuthenticatedRoute exact path='/v2/test' component={TestsMain} />
        <AuthenticatedRoute exact path='/quick-test' component={QuickTest} />
        <AuthenticatedRoute exact path='/test-analysis' component={AnalysisNew} />
        <AuthenticatedRoute exact path='/course-analysis' component={CourseAnalysis} />
        <AuthenticatedRoute
          exact
          path='/all-mulyankan-tests'
          component={AllCreatedTestsMulyankan}
        />
        <AuthenticatedRoute exact path='/all-tests' component={AllCreatedTests} />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/library/all-tests'
          component={AllCreatedTestsMulyankan}
        />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/v2/homework/finalpreview'
          component={FinalQuestionsNew}
        />
        <AuthenticatedRoute exact path='/v2/homework/createdtest' component={CreatedTest} />
        <AuthenticatedRouteWithoutSidebar exact path='/homework/assign' component={HomeWorkAssigner} />
        <AuthenticatedRouteWithoutSidebar exact path='/homework/viewonly' component={HomeWorkViewOnly} />
        <AuthenticatedRoute exact path='/campaign' component={Campaign} />
        <AuthenticatedRoute exact path='/campaign-dashboard' component={CampaignDashboard} />
        <AuthenticatedRoute exact path='/campaign-details' component={CampaignDetails} />
        <AuthenticatedRoute exact path='/courses' component={ViewCourses} />
        <Route exact path='/explore/allcourses' component={ExploreAllCourses} />
        <AuthenticatedRoute exact path='/allcourses' component={AllCourses} />
        <Route exact path='/courses/buyCourse/:clientId?/:courseId?' component={BuyCourse} />
        <Route exact path='/course-checkout' component={CourseCheckout} />
        <Route exact path='/view-course/:clientId?/:courseId?' component={CourseLandingPage} />
        <Route exact path='/buycourse/:clientId?/:courseId?' component={CourseLandingPage3} />
        <AuthenticatedRouteWithoutSidebar exact path='/courses/mycourse' component={Mycourse} />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/courses/viewcourse'
          component={MycourseWithoutPlayer}
        />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/courses/certificate'
          component={Certificate}
        />
        <AuthenticatedRoute exact path='/courses/teachercourse' component={TeacherCourses} />
        <AuthenticatedRoute exact path='/courses/invoice' component={CourseInvoice} />
        <AuthenticatedRoute
          exact
          path='/courses/invoice-separate'
          component={CourseInvoiceSeparate}
        />
        <AuthenticatedRoute exact path='/fees/invoice' component={FeeInvoice} />
        <AuthenticatedRoute
          exact
          path='/courses/teachercourse/statistics'
          component={CourseStatistics}
        />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/courses/createcourse'
          component={CreateCourse}
        />
        <AuthenticatedRoute exact path='/courses/manage-category' component={ManageCategories} />
        <AuthenticatedRouteWithoutSidebar exact path='/courses/manage-validity' component={ManageValidity} />
        <AuthenticatedRoute
          path='/courses/validity-updates'
          component={UpdatedValidityList}
        />
        <AuthenticatedRouteWithoutSidebar exact path='/courses/createcourse/addcontent' component={AddContent} />
        <AuthenticatedRoute  path='/subscription-pause-logs' component={SubscriptionPauseLogs} />
        <AuthenticatedRoute exact path='/admissions' component={Admissions} />
        <AuthenticatedRoute exact path='/admissions/user' component={UserDetails} />
        <AuthenticatedRoute exact path='/admissions/batch' component={BatchDetails} />
        <AuthenticatedRoute exact path='/admissions/batch/addusers' component={AddUsersToBatch} />
        <AuthenticatedRoute exact path='/admissions/add/details' component={AddDetails} />
        <AuthenticatedRoute exact path='/admissions/add/fees' component={AddFees} />
        <AuthenticatedRoute exact path='/admissions/add/class' component={SelectClass} />
        <AuthenticatedRoute exact path='/admissions/add/batch' component={AddBatch} />
        <AuthenticatedRoute exact path='/admissions/editprofile' component={EditProfileHOC} />
        <AuthenticatedRoute exact path='/payment-settings' component={PaymentSettings} />
        <AuthenticatedRoute exact path='/login-settings' component={LoginSettings} />
        <AuthenticatedRoute exact path='/app-settings' component={AppSettings} />
        <AuthenticatedRoute exact path='/settlements' component={SettlementsPage} />
        <AuthenticatedRoute exact path='/my-credit-profile' component={MyCreditProfile} />
        <AuthenticatedRoute exact path='/credits-analytics' component={CreditsAnalytics} />
        <AuthenticatedRoute path='/settlements/breakdown' component={SettlementsBreakdown} />

        <AuthenticatedRouteWithoutSidebar exact path='/conversations' component={Conversations} />
        <AuthenticatedRouteWithoutSidebar exact path='/conversation' component={Conversation} />
        <AuthenticatedRouteWithoutSidebar exact path='/image-editor' component={ImageEditor} />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/conversation/details'
          component={ConversationDetails}
        />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/conversations/:id/media'
          component={ConversationMedia}
        />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/conversations/:id/:type'
          component={ConversationFiles}
        />
        <AuthenticatedRouteWithoutSidebar exact path='/create-post' component={CreatePost} />
        <AuthenticatedRouteWithoutSidebar exact path='/posts/:id' component={Post} />

        <AuthenticatedRoute exact path='/analysis/teacher' component={TeacherAnalysis} />
        <AuthenticatedRoute exact path='/analysis/assignment' component={AssignmentList} />
        <AuthenticatedRoute
          exact
          path='/analysis/subjectiveassignment'
          component={SubjectiveAnalysis}
        />
        <AuthenticatedRoute exact path='/analysis/studentanalysis' component={StudentAnalysis} />
        <AuthenticatedRouteWithoutSidebar exact path='/test-analysis/eomranalysis' component={StudentAnalysis} />
        <AuthenticatedRoute
          exact
          path='/analysis/studentsubjectiveanalysis'
          component={StudentSubjectiveAnalysis}
        />
        <AuthenticatedRoute exact path='/analysis/studentlist' component={StudentList} />
        <AuthenticatedRoute exact path='/attendance' component={Attendance} />
        <AuthenticatedRoute exact path='/analysis' component={Analysis} />
        <AuthenticatedRoute exact path='/attendance/batch' component={AttendanceBatch} />
        <AuthenticatedRoute exact path='/attendance/date' component={SelectedDateAttendance} />
        <AuthenticatedRoute exact path='/displaypage' component={DisplayPage} />
        <AuthenticatedRoute exact path='/displaypage/editprofile' component={DisplayPageEdit} />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/displaypage/preview'
          component={DummyDashboard}
        />
        <Route exact path='/main' component={DummyDashboard} />
        <Route exact path='/main2' component={DummyDashboard2} />
        <AuthenticatedRoute exact path='/offlineassignments' component={OfflineAssignments} />
        <AuthenticatedRoute exact path='/teacherfees/accountdetails' component={SettlementPage} />
        <AuthenticatedRoute exact path='/teacherfees/editaccountdetails' component={EditPayments} />
        <AuthenticatedRoute exact path='/teacherfees/edittaxdetails' component={EditTaxDetails} />
        <AuthenticatedRoute
          exact
          path='/offlineassignments/addassignment'
          component={AssignmentForm}
        />

         <AuthenticatedRoute
          exact
          path='/forms'
          component={Forms}
        />
        <AuthenticatedRoute
          
          path='/admission-form-response'
          component={AdmissionFormResponses}
        />
        <AuthenticatedRoute
          exact
          path='/offlineassignments/editassignment'
          component={EditAssignment}
        />
        <AuthenticatedRoute
          exact
          path='/offlineassignments/studentmarks'
          component={StudOfflineMarks}
        />
        <AuthenticatedRoute
          exact
          path='/offlineassignments/studentmarks/editmarks'
          component={StudEdit}
        />

        <AuthenticatedRoute exact path='/notifications' component={Notifications} />

        <AuthenticatedRoute exact path='/crm' component={CRM} />
        <AuthenticatedRoute exact path='/aileads' component={AILeads} />
        <AuthenticatedRoute exact path='/crm/user' component={UserDetails} />
        <AuthenticatedRoute exact path='/crm/editprofile' component={EditProfileHOC} />
        <AuthenticatedRoute exact path='/usage' component={Usage} />
        <AuthenticatedRouteWithoutSidebar exact path='/usage-dashboard' component={Usage} />
        <AuthenticatedRoute exact path='/transactions' component={Transactions} />
        <AuthenticatedRoute exact path='/creditorder' component={Creditpayment} />
        <AuthenticatedRoute exact path='/invoice' component={Invoice} />
        <AuthenticatedRoute exact path='/usageupdate' component={UsageUpdate} />
        <AuthenticatedRoute exact path='/servicecharges' component={ServiceCharges} />
        <AuthenticatedRoute exact path='/invoices-list' component={ClientInvoices} />
        <AuthenticatedRoute exact path='/student-invoices' component={StudentInvoices} />
        <AuthenticatedRoute exact path='/my-invoice' component={ClientInvoice} />
        <AuthenticatedRoute exact path='/folder/:id' component={MulyankanFolders} />
        <AuthenticatedRoute
          exact
          path='/user-permission-control'
          component={UserPermissionControl}
        />
        <AuthenticatedRoute exact path='/user-feature-access' component={UserFeatureAccess} />
        <Route exact path='/videoshow' component={VideoShow} />
        <Route exact path='/service-unavailable' component={ServiceUnavailable} />
        <Route exact path='/userservice-unavailable' component={StudentServiceUnavailable} />
        <Route exact path='/browser-restricted' component={BrowserRestricted} />
        <Route exact path='/authenticateuser' component={AuthenticateUser} />

        <Route exact path='/chatbot' component={Chatbot} />
        <AuthenticatedRouteWithoutSidebar exact path='/dailyquiz' component={Quiz} />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/saral-leaderboard'
          component={SaralLeaderboard}
        />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/karyakarta-certificate'
          component={KaryakartaCertificate}
        />
        <AuthenticatedRouteWithoutSidebar
          exact
          path='/karyakarta-certificate-testing'
          component={KaryakartaCertificate}
        />

        {/* Aplayer routes  */}

        <Route path='/fileviewer' component={FileView} />
        <Route path='/oldfileviewer' component={OldFileView} />
        <Route path='/otherfileviewer' component={TempViewFile} />
        <Route path='/payment-page' component={PaymentPage} />
        <Route path='/payment-success' component={PaymentDummy} />
        <Route path='/payment-link' component={PaymentLink} />

        {/* If error occurs */}

        <Route exact path='/error' component={ErrorCode} />
        <Route exact path='/course-access-invalid' component={InvalidCourse} />

        {/* redirect user to FourZeroFour page if route does not exist */}

        <Route exact path='/invalidurl' component={InvalidURL} />

        <Route component={FourZeroFour} />
      </Switch>
    </>
    // </div>
  );
}
